const SBOX_TYPE = 'sBox';
const SLIGHT_TYPE = 'sLight';
const KISIO_TYPE = 'kisIo';
const DATAPOINT_IS_ONLINE = 'isOnline';
const DATAPOINT_PIN1 = 'pin1';
const DATAPOINT_PIN2 = 'pin2';
const DATAPOINT_PIN3 = 'pin3';
const DATAPOINT_PIN4 = 'pin4';
const DATAPOINT_PIN1_STATUS = 'pin1Status';
const DATAPOINT_PIN2_STATUS = 'pin2Status';
const DATAPOINT_PIN3_STATUS = 'pin3Status';
const DATAPOINT_PIN4_STATUS = 'pin4Status';
const DATAPOINT_PIN1_FREQUENCY = 'pin1Frequency';
const DATAPOINT_PIN2_FREQUENCY = 'pin2Frequency';
const DATAPOINT_PIN3_FREQUENCY = 'pin3Frequency';
const DATAPOINT_PIN4_FREQUENCY = 'pin4Frequency';
const DATAPOINT_PIN1_MODE = 'pin1Mode';
const DATAPOINT_PIN2_MODE = 'pin2Mode';
const DATAPOINT_PIN3_MODE = 'pin3Mode';
const DATAPOINT_PIN4_MODE = 'pin4Mode';
const DATAPOINT_LED = 'led1';
const DATAPOINT_LED_COLOR = 'led1Color';
const DATAPOINT_LED_FREQUENCY = 'led1Frequency';
const DATAPOINT_BUTTON1 = 'button1';
const DATAPOINT_BUTTON2 = 'button2';
const DATAPOINT_BUTTON_COLOR1 = 'button1Color';
const DATAPOINT_BUTTON_COLOR2 = 'button2Color';
const DATAPOINT_BUTTON_FREQUENCY1 = 'button1Frequency';
const DATAPOINT_BUTTON_FREQUENCY2 = 'button2Frequency';
// Asset Info Datapoints
// HARDWARE
const DATAPOINT_PART_NUMBER = 'partNumber';
const DATAPOINT_SERIAL_NUMBER = 'serialNumber';
const DATAPOINT_DATA_MATRIX_CODE = 'dataMatrixCode';
const DATAPOINT_MAC_ADRESS = 'macAddress';
const DATAPOINT_HARDWARE_REVISION = 'hardwareRevision';
// SOFTWARE
const DATAPOINT_OS_VERSION = 'osVersion';
const DATAPOINT_APPLICATION_VERSION = 'appVersion';
// applocation version is missing
const DATAPOINT_FIRMWARE_VERSION = 'firmwareVersion';
const DATAPOINT_BOOTLOADER_VERSION = 'bootloaderVersion';
const DATAPOINT_OPEN_SSL_VERSION = 'opensslVersion';
// NETWORK
const DATAPOINT_WIFI_SSID = 'wifiSsid';
const DATAPOINT_WIFI_SIGNAL_STRENGTH = 'wifiSignalStrength';
const DATAPOINT_WIFI_CHANNEL = 'wifiChannel';
const DATAPOINT_IP_ADRESS = 'ipAddress';
const DATAPOINT_SUBNET = 'subnet';
const DATAPOINT_GATEWAY = 'gateway';
// CERTIFICATE
const DATAPOINT_CERTIFICATE_EXPIRATION = 'certificateExpiresAt';
// FIRMWARE
const DATAPOINT_DESIRED_JOBS_JOB_ID = 'desiredJobsFwJobId';
const DATAPOINT_REPORTED_JOBS_JOB_ID = 'reportedJobsFwJobId';
const DATAPOINT_REPORTED_JOBS_BUNDLE_ID = 'reportedJobsFwBundleId';
const DATAPOINT_REPORTED_JOBS_VERSION_ID = 'reportedJobsFwBundleVersionId';
const DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER = 'reportedJobsFwSequenceNumber';
const DATAPOINT_REPORTED_JOBS_UPDATE_STATUS = 'reportedJobsFwUpdateStatus';
export const BUTTON_NAME_MAPPING = {
	button1: 'Button 1',
	button2: 'Button 2'
};
export const GPIO_MODE_INPUT = 'input';
export const GPIO_MODE_OUTPUT = 'output';
export const GPIO_MODES = {
	INPUT: GPIO_MODE_INPUT,
	OUTPUT: GPIO_MODE_OUTPUT
};
export const GPIO_STATUS_HIGH = true;
export const GPIO_STATUS_LOW = false;
export const GPIO_STATUSES = {
	HIGH: GPIO_STATUS_HIGH,
	LOW: GPIO_STATUS_LOW
};
export const DEVICE_ONLINE_STATUS_ONLINE = true;
export const DEVICE_ONLINE_STATUS_OFFLINE = false;
export const DEVICE_ONLINE_STATUS = {
	ONLINE: DEVICE_ONLINE_STATUS_ONLINE,
	OFFLINE: DEVICE_ONLINE_STATUS_OFFLINE
};
const DATAPOINT_BLINK_MAPPING: Record<string, string> = {
	[DATAPOINT_BUTTON_COLOR1]: DATAPOINT_BUTTON_FREQUENCY1,
	[DATAPOINT_BUTTON_COLOR2]: DATAPOINT_BUTTON_FREQUENCY2,
	[DATAPOINT_LED_COLOR]: DATAPOINT_LED_FREQUENCY
};
const GPIO_MODE_MAPPING: Record<string, string> = {
	[DATAPOINT_PIN1_MODE]: DATAPOINT_PIN1,
	[DATAPOINT_PIN2_MODE]: DATAPOINT_PIN2,
	[DATAPOINT_PIN3_MODE]: DATAPOINT_PIN3,
	[DATAPOINT_PIN4_MODE]: DATAPOINT_PIN4
};
export {
	SLIGHT_TYPE,
	SBOX_TYPE,
	KISIO_TYPE,
	DATAPOINT_IS_ONLINE,
	DATAPOINT_BUTTON1,
	DATAPOINT_BUTTON2,
	DATAPOINT_BUTTON_COLOR2,
	DATAPOINT_BUTTON_COLOR1,
	DATAPOINT_BUTTON_FREQUENCY1,
	DATAPOINT_BUTTON_FREQUENCY2,
	DATAPOINT_LED,
	DATAPOINT_LED_COLOR,
	DATAPOINT_LED_FREQUENCY,
	DATAPOINT_BLINK_MAPPING,
	DATAPOINT_PIN1,
	DATAPOINT_PIN2,
	DATAPOINT_PIN3,
	DATAPOINT_PIN4,
	DATAPOINT_PIN1_STATUS,
	DATAPOINT_PIN2_STATUS,
	DATAPOINT_PIN3_STATUS,
	DATAPOINT_PIN4_STATUS,
	DATAPOINT_PIN1_FREQUENCY,
	DATAPOINT_PIN2_FREQUENCY,
	DATAPOINT_PIN3_FREQUENCY,
	DATAPOINT_PIN4_FREQUENCY,
	DATAPOINT_PIN1_MODE,
	DATAPOINT_PIN2_MODE,
	DATAPOINT_PIN3_MODE,
	DATAPOINT_PIN4_MODE,
	GPIO_MODE_MAPPING,
	DATAPOINT_PART_NUMBER,
	DATAPOINT_SERIAL_NUMBER,
	DATAPOINT_DATA_MATRIX_CODE,
	DATAPOINT_MAC_ADRESS,
	DATAPOINT_HARDWARE_REVISION,
	DATAPOINT_OS_VERSION,
	DATAPOINT_FIRMWARE_VERSION,
	DATAPOINT_BOOTLOADER_VERSION,
	DATAPOINT_OPEN_SSL_VERSION,
	DATAPOINT_WIFI_SSID,
	DATAPOINT_WIFI_SIGNAL_STRENGTH,
	DATAPOINT_WIFI_CHANNEL,
	DATAPOINT_IP_ADRESS,
	DATAPOINT_SUBNET,
	DATAPOINT_GATEWAY,
	DATAPOINT_CERTIFICATE_EXPIRATION,
	DATAPOINT_APPLICATION_VERSION,
	DATAPOINT_DESIRED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_BUNDLE_ID,
	DATAPOINT_REPORTED_JOBS_VERSION_ID,
	DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER,
	DATAPOINT_REPORTED_JOBS_UPDATE_STATUS
};
export const PIN_NUMBERS = [1, 2, 3, 4];
export const BUNDLE_MANAGEMENT_ROUTE_ABSOLUTE_PATH = '/portaladmin/bundleManagement';
// Licence
export const AUTHORITY_READ_ASSET_DATAPOINT_APP = 'READ_ASSET_DATAPOINT_APP';
export const AUTHORITY_READ_RULE_OPTIONAL_SETTING = 'READ_RULE_OPTIONAL_SETTING';
export const AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION = 'READ_KPI_DATA_PROCESSING_DEFINITION';
export const AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION = 'CREATE_KPI_DATA_PROCESSING_DEFINITION';
export const AUTHORITY_UPDATE_KPI_DATA_PROCESSING_DEFINITION = 'UPDATE_KPI_DATA_PROCESSING_DEFINITION';
export const AUTHORITY_DELETE_KPI_DATA_PROCESSING_DEFINITION = 'DELETE_KPI_DATA_PROCESSING_DEFINITION';
export const AUTHORITY_ACCESS_TO_ALL_KPI_DATA_PROCESSING_DEFINITIONS = 'ACCESS_TO_ALL_KPI_DATA_PROCESSING_DEFINITIONS';
export const AUTHORITY_ASSIGN_KPI_DATA_PROCESSING_DEFINITION_TO_ASSET =
	'ASSIGN_KPI_DATA_PROCESSING_DEFINITION_TO_ASSET';
export const AUTHORITY_ASSIGN_KPI_DATA_PROCESSING_DEFINITION_TO_ASSET_GROUP =
	'ASSIGN_KPI_DATA_PROCESSING_DEFINITION_TO_ASSET_GROUP';

export const DATAPOINT_WIDGET_NAMES = ['trend', 'trendv2'];
export const DATAPOINT_APP_RELATIVE_PATH = 'datapoints';

// KIS.Api Custom Page Authorities
export const AUTHORITY_READ_SUBTENANT = 'READ_SUBTENANT';
export const AUTHORITY_READ_KIS_API_USER = 'READ_KIS_API_USER';
export const AUTHORITY_WRITE_KIS_API_USER = 'WRITE_KIS_API_USER';

// Asset Management Authorities
export const DELETE_DEVICE = 'DELETE_DEVICE';

// Custom Datapoints Authorities
export const READ_CUSTOM_DATAPOINT = 'READ_CUSTOM_DATAPOINT';
export const WRITE_CUSTOM_DATAPOINT = 'WRITE_CUSTOM_DATAPOINT';
